import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import {
	postTachesAutre,
	postTachesAutreReset,
	deleteTacheAutre,
	deleteTacheAutreReset,
} from "../../../store/actions/autreActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import CustomModal from "../../basics/interface/CustomModal"

// Édition d'une tâche (modal V2). POST attend un tableau [{id, texte}] ; POST et
// DELETE renvoient { taches: [...] } → le reducer (autreInfo.taches) met la
// table à jour seul.
const TacheModalV2 = ({ tache, onClose }) => {
	const dispatch = useDispatch()
	const postState = useSelector((s) => s.autreInfo.postTaches)
	const deleteState = useSelector((s) => s.autreInfo.deleteTache)
	const isCreate = !tache.id
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [texte, setTexte] = useState(tache.texte || "")

	// Fermeture après une sauvegarde OU une suppression réussie.
	useEffect(() => {
		if (!postState.saved && !deleteState.deleted) return
		const t = setTimeout(() => {
			dispatch(postTachesAutreReset())
			dispatch(deleteTacheAutreReset())
			onClose()
		}, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [postState.saved, deleteState.deleted])

	useEffect(
		() => () => {
			dispatch(postTachesAutreReset())
			dispatch(deleteTacheAutreReset())
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	)

	// Quitte le mode "confirmer" si la suppression échoue (tâche protégée).
	useEffect(() => {
		if (deleteState.error) setConfirmDelete(false)
	}, [deleteState.error])

	const invalid = !texte.trim()

	const save = () => {
		const payload = [{ id: tache.id || null, texte: texte.trim() }]
		dispatch(postTachesAutre(JSON.stringify(payload)))
	}
	const remove = () => {
		if (!confirmDelete) {
			setConfirmDelete(true)
			return
		}
		dispatch(deleteTacheAutre(JSON.stringify({ id: tache.id })))
	}

	const busy =
		postState.saving ||
		postState.saved ||
		deleteState.deleting ||
		deleteState.deleted

	const buttons = []
	if (!isCreate) {
		buttons.push({
			title: deleteState.deleting ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : confirmDelete ? (
				"Confirmer ?"
			) : (
				"Supprimer"
			),
			styleName: "danger",
			onClick: remove,
			disabled: busy,
		})
	}
	buttons.push({
		title: "Annuler",
		styleName: "secondary",
		onClick: onClose,
		disabled: busy,
	})
	buttons.push({
		title: postState.saving ? (
			<FontAwesomeIcon icon={faSync} spin />
		) : postState.saved ? (
			<FontAwesomeIcon icon={faCheck} />
		) : (
			"Enregistrer"
		),
		styleName: "primary",
		onClick: save,
		disabled: busy || invalid,
	})

	return (
		<CustomModal
			title={isCreate ? "Nouvelle tâche" : "Éditer la tâche"}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={buttons}
		>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>
						Texte<span style={{ color: COLORS.danger }}> *</span>
					</label>
					<input
						style={gs.input}
						value={texte}
						onChange={(e) => setTexte(e.target.value)}
						autoFocus
					/>
				</div>
			</div>
		</CustomModal>
	)
}

export default TacheModalV2
